import { AssignmentFileUploadForm } from "@/app/ProDrivers/WorkOrders/Components/Forms/AssignmentFileUploadForm";

export function AssignmentFilesTab({ assignmentId }: { assignmentId: string }) {
  return <AssignmentFileUploadForm assignmentId={assignmentId} />;
}
